import styles from "./SubFooter.module.css";

function SubFooter({ subfooter }) {
  return (
    <div className={styles.subfooter}>
      <h1>{subfooter.title}</h1>
      {subfooter.content.map((element) => (
        <h4 key={element}>{element}</h4>
      ))}
    </div>
  );
}
export default SubFooter;
